<template>
  <vs-popup class="popupSearchField" :title="title" :active.sync="showPopup">
    <vs-tabs v-if="tabList.length > 1" v-model="tabIndex">
      <vs-tab v-for="tab of tabList" :key="tab.key" :label="tab.label" @click="onClickTab(tab.key)"/>
    </vs-tabs>
    <!-- 사업장(직접수행) -->
    <div v-if="tabIndex === 0">
      <vs-row class="pb-2 text-center" style="border-bottom:1px solid #e0e0e0">
        <vs-col class="w-10/12 flex" vs-align="center">
          <vs-col class="w-4/12 flex" vs-align="center">
            <span class="w-4/12">검색어</span>
            <ml-input ref="inputKeyword" class="w-8/12" v-model="search.keyword" @keyup.enter="handleClickSearch"/>
          </vs-col>
        </vs-col>
        <vs-col class="w-2/12 text-right">
          <vs-button color="secondary" @click="handleClickSearch">검색</vs-button>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col style="max-height:520px; overflow-y:auto;">

          <vs-table stripe
                    ref="table"
                    :sst="true"
                    :max-items="page.perPage"
                    :data="fieldList"
                    noDataText="데이터가 없습니다"
                    @selected="handleItemClickDetail"
          >

            <template slot="thead">
              <vs-th class=""><span class="w-full h-full">No.</span></vs-th>
              <vs-th class=""><span class="w-full h-full">{{ getFieldName }}</span></vs-th>
              <vs-th class=""><span class="w-full h-full">주소</span></vs-th>
              <vs-th class=""><span class="w-full h-full">사업기간</span></vs-th>
              <vs-th class=""><span class="w-full h-full">사업금액</span></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr v-for="(field, index) in data" :key="index"
                     :class="(selectField && selectField.id === field.id) ? 'active' : '' "
                     :data="field">

                <vs-td>{{ field.id }}</vs-td>
                <vs-td>{{ field.field_name }}</vs-td>
                <vs-td>{{ field.address }}</vs-td>
                <vs-td>{{ field.start_work_at || field.be_completed_at ? (field.start_work_at ? getFormattedDate(field.start_work_at) : '') + ' ~ ' + (field.be_completed_at ? getFormattedDate(field.be_completed_at): '') : '-' }}</vs-td>
                <vs-td>{{ field.deposit_amount ? new Intl.NumberFormat().format(parseInt(field.deposit_amount.replace(/,/g, '')) || 0) : '-' }}</vs-td>

              </vs-tr>
            </template>

          </vs-table>

          <div class="vs-con-table">
            <div class="con-pagination-table vs-table--pagination">
              <k-pagination
                :total="(page.lastPage) ? page.lastPage : 0"
                v-model="page.current" @change="handleChangePage"></k-pagination>
            </div>
          </div>

        </vs-col>

        <vs-col class="mt-4 flex" vs-align="center" vs-justify="flex-end">
          <vs-button class="mr-4 " color="#EDEDED" text-color="black" type="filled" @click="handleClickClose">닫기
          </vs-button>
          <vs-button class="" color="secondary" @click="handleClickSelect">선택</vs-button>
        </vs-col>

      </vs-row>
    </div>

    <!-- 사업장(용역위탁) -->
    <div v-else-if="tabIndex === 1">
      <vs-row class="pb-2 text-center" style="border-bottom:1px solid #e0e0e0">
        <vs-col class="w-10/12 flex" vs-align="center">
          <vs-col class="w-4/12 flex" vs-align="center">
            <span class="w-4/12">검색어</span>
            <ml-input class="w-8/12" v-model="search.keyword"/>
          </vs-col>
        </vs-col>
        <vs-col class="w-2/12 text-right">
          <vs-button color="secondary" @click="handleClickSearch">검색</vs-button>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col style="max-height:500px; overflow-y:auto;">

          <vs-table stripe
                    ref="table"
                    :sst="true"
                    :max-items="page.perPage"
                    :data="fieldList"
                    noDataText="데이터가 없습니다"
                    @selected="handleItemClickDetail"
          >

            <template slot="thead">
              <vs-th class=""><span class="w-full h-full">No.</span></vs-th>
              <vs-th class=""><span class="w-full h-full">사업장명</span></vs-th>
              <vs-th class=""><span class="w-full h-full">주소</span></vs-th>
              <vs-th class=""><span class="w-full h-full">사업기간</span></vs-th>
              <vs-th class=""><span class="w-full h-full">사업금액</span></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr v-for="(field, index) in data" :key="index"
                     :class="(selectField && selectField.id === field.id) ? 'active' : '' "
                     :data="field">

                <vs-td>{{ field.id }}</vs-td>
                <vs-td>{{ field.field_name }}</vs-td>
                <vs-td>{{ field.address }}</vs-td>
                <vs-td>{{ field.work_begin_at || field.work_end_at ? (field.work_begin_at ? getFormattedDate(field.work_begin_at) : '') + ' ~ ' + (field.work_end_at ? getFormattedDate(field.work_end_at): '') : '-' }}</vs-td>
                <vs-td>{{ field.deposit_amount ? new Intl.NumberFormat().format(parseInt(field.deposit_amount.replace(/,/g, '')) || 0) : '-' }}</vs-td>

              </vs-tr>
            </template>

          </vs-table>

          <div class="vs-con-table">
            <div class="con-pagination-table vs-table--pagination">
              <k-pagination
                :total="(page.lastPage) ? page.lastPage : 0"
                v-model="page.current" @change="handleChangePage"></k-pagination>
            </div>
          </div>

        </vs-col>

        <vs-col class="mt-4 flex" vs-align="center" vs-justify="flex-end">
          <vs-button class="mr-4 " color="#EDEDED" text-color="black" type="filled" @click="handleClickClose">닫기
          </vs-button>
          <vs-button class="" color="secondary" @click="handleClickSelect">선택</vs-button>
        </vs-col>

      </vs-row>
    </div>

    <!-- 사업장(도급발주) -->
    <div v-else-if="tabIndex === 2">
      <vs-row class="pb-2 text-center" style="border-bottom:1px solid #e0e0e0">
        <vs-col class="w-10/12 flex" vs-align="center">
          <vs-col class="w-4/12 flex" vs-align="center">
            <span class="w-4/12">검색어</span>
            <ml-input class="w-8/12" v-model="search.keyword"/>
          </vs-col>
        </vs-col>
        <vs-col class="w-2/12 text-right">
          <vs-button color="secondary" @click="handleClickSearch">검색</vs-button>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col style="max-height:500px; overflow-y:auto;">

          <vs-table stripe
                    ref="table"
                    :sst="true"
                    :max-items="page.perPage"
                    :data="fieldList"
                    noDataText="데이터가 없습니다"
                    @selected="handleItemClickDetail"
          >

            <template slot="thead">
              <vs-th class=""><span class="w-full h-full">No.</span></vs-th>
              <vs-th class=""><span class="w-full h-full">사업장명</span></vs-th>
              <vs-th class=""><span class="w-full h-full">주소</span></vs-th>
              <vs-th class=""><span class="w-full h-full">사업기간</span></vs-th>
              <vs-th class=""><span class="w-full h-full">사업금액</span></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr v-for="(field, index) in data" :key="index"
                     :class="(selectField && selectField.id === field.id) ? 'active' : '' "
                     :data="field">
                <vs-td class="">{{ field.id }}</vs-td>
                <vs-td class="">{{ field.field_name }}</vs-td>
                <vs-td class="">{{ field.address }}</vs-td>
                <vs-td>{{ field.start_work_at || field.be_completed_at ? (field.start_work_at ? getFormattedDate(field.start_work_at) : '') + ' ~ ' + (field.be_completed_at ? getFormattedDate(field.be_completed_at): '') : '-' }}</vs-td>
                <vs-td class="">{{ field.deposit_amount ? new Intl.NumberFormat().format(parseInt(field.deposit_amount.replace(/,/g, '')) || 0) : '-' }}</vs-td>
              </vs-tr>
            </template>

          </vs-table>

          <div class="vs-con-table">
            <div class="con-pagination-table vs-table--pagination">
              <k-pagination
                :total="(page.lastPage) ? page.lastPage : 0"
                v-model="page.current" @change="handleChangePage"></k-pagination>
            </div>
          </div>

        </vs-col>

        <vs-col class="mt-4 flex" vs-align="center" vs-justify="flex-end">
          <vs-button class="mr-4 " color="#EDEDED" text-color="black" type="filled" @click="handleClickClose">닫기
          </vs-button>
          <vs-button class="" color="secondary" @click="handleClickSelect">선택</vs-button>
        </vs-col>

      </vs-row>
    </div>

    <!-- 시설물 -->
    <div v-else-if="tabIndex === 3">
      <vs-row class="pb-2 text-center" style="border-bottom:1px solid #e0e0e0">
        <vs-col class="w-10/12 flex" vs-align="center">
          <vs-col class="w-4/12 flex" vs-align="center">
            <span class="w-4/12">검색어</span>
            <ml-input class="w-8/12" v-model="search.keyword"/>
          </vs-col>
        </vs-col>
        <vs-col class="w-2/12 text-right">
          <vs-button color="secondary" @click="handleClickSearch">검색</vs-button>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col style="max-height:500px; overflow-y:auto;">

          <vs-table stripe
                    ref="table"
                    :sst="true"
                    :max-items="page.perPage"
                    :data="fieldList"
                    noDataText="데이터가 없습니다"
                    @selected="handleItemClickDetail"
          >

            <template slot="thead">
              <vs-th class=""><span class="w-full h-full">No.</span></vs-th>
              <vs-th class=""><span class="w-full h-full">시설물명</span></vs-th>
              <vs-th class=""><span class="w-full h-full">주소</span></vs-th>
              <vs-th class=""><span class="w-full h-full">사업기간</span></vs-th>
              <vs-th class=""><span class="w-full h-full">사업금액</span></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr v-for="(field, index) in data" :key="index"
                     :class="(selectField && selectField.id === field.id) ? 'active' : '' "
                     :data="field">
                <vs-td class="">{{ field.id }}</vs-td>
                <vs-td class="">{{ field.field_name }}</vs-td>
                <vs-td class="">{{ field.address }}</vs-td>
                <vs-td>{{ field.start_work_at || field.be_completed_at ? (field.start_work_at ? getFormattedDate(field.start_work_at) : '') + ' ~ ' + (field.be_completed_at ? getFormattedDate(field.be_completed_at): '') : '-' }}</vs-td>
                <vs-td class="">{{ field.deposit_amount ? new Intl.NumberFormat().format(parseInt(field.deposit_amount.replace(/,/g, '')) || 0) : '-' }}</vs-td>
              </vs-tr>
            </template>

          </vs-table>

          <div class="vs-con-table">
            <div class="con-pagination-table vs-table--pagination">
              <k-pagination
                :total="(page.lastPage) ? page.lastPage : 0"
                v-model="page.current" @change="handleChangePage"></k-pagination>
            </div>
          </div>

        </vs-col>

        <vs-col class="mt-4 flex" vs-align="center" vs-justify="flex-end">
          <vs-button class="mr-4 " color="#EDEDED" text-color="black" type="filled" @click="handleClickClose">닫기
          </vs-button>
          <vs-button class="" color="secondary" @click="handleClickSelect">선택</vs-button>
        </vs-col>

      </vs-row>
    </div>
  </vs-popup>
</template>


<script>

import KPagination from '@/components/kPagination/kPagination'
import moment from "moment";
import Vue from "vue";

export default {

  name: 'PopupSearchField',
  components: {KPagination},
  props: {
    value: Boolean,
    selectId: [String, Number],
    useTypes: Array
  },
  computed: {
    getFieldName () {
      if (this.tabList.length > 0) {
        return this.tabList[this.tabIndex].field_name
      }
      return '사업장명'
    },
    title() {
      let title = '사업장';
      if(typeof this.useTypes !== 'undefined' && typeof this.useTypes.length !== 'undefined' && this.useTypes.length === 1) {
        title = this.useTypes[0];
      }

      switch(title) {
        case '사업장(용역위탁)':
          title = '사업장(도급·용역·위탁)';
          break;
        case '사업장(도급발주)':
          title = '사업장(발주)';
          break;
      }
      return `${title} 불러오기`;
    },
    tabList () {
      const list = []
      if (this.useTypes && this.useTypes.length > 0) {
        for (const type of this.useTypes) {
          if (type === '사업장(직접수행)') list.push({ label: '직영사업장', field_name:'사업장명', key: type })
          if (type === '사업장(용역위탁)') list.push({ label: '도급·용역·위탁 사업장', field_name:'사업장명', key: type })
          if (type === '사업장(도급발주)') list.push({ label: '발주 사업장', field_name:'사업장명', key: type })
          if (type === '시설물') list.push({ label: '시설물', field_name:'시설물명', key: type })
        }
      }
      return list
    },
    projectId () {
      return parseInt(this.$route.params.proj_id)
    },
    fieldList () {
      const info = this.$store.state.project.fieldListInfo
      const list = info.data

      if (list) {
        this.page.current = info.current_page
        this.page.perPage = info.per_page
        this.page.lastPage = info.last_page

        for (const field of list) {
          if (field.id === this.oldSelectFieldId) {
            this.oldSelectField = field
            this.selectField = field
            break
          }
        }

        return list
      } else {
        return []
      }
    },
    getType () {
      return this.type
    }
  },
  watch: {
    value (data) {
      this.showPopup = data
      if (this.oldSelectField && this.oldSelectField.id) {
        this.selectField = this.oldSelectField
      }

      // 팝업이 열리면, 검색어 입력창에 포커스가 오도록 한다
      if(data) {
        let self = this;
        Vue.nextTick().then(function () {
          self.$refs.inputKeyword.$el.querySelector('input').focus();
        });
      }
    },
    selectId (id) {
      this.oldSelectFieldId = id
      if (this.fieldList && this.fieldList.length > 0) {
        for (const field of this.fieldList) {
          if (field.id === this.oldSelectFieldId) {
            try {
              this.oldSelectField = field
              this.selectField = field
            } catch (e) {
            }
            break
          }
        }
      }
    },
    showPopup (data) {
      this.selectField = this.oldSelectField
      this.$emit('input', data)
      this.loadFieldList()
    },
    useTypes :{
      immediate: true,
      handler (type) {
        if (type && type.length > 0) {
          let i = 0;
          for (i = 0; i < this.useTypes.length; i++) {
            this.tabIndex = i;
            const type = this.useTypes[i]
            this.selectTab = {[this.id]: type} //useTypes
            if (type === '사업장(직접수행)') break
            else if (type === '사업장(용역위탁)') break
            else if (type === '사업장(도급발주)') break
            else if (type === '시설물') break
          }
        }
      }
    }
  },
  data () {
    return {
      id: null,
      showPopup: false,

      oldSelectFieldId: 0,
      oldSelectField: {},
      selectField: {},

      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 10
      },

      // 겅색
      search: {
        loading: false,
        keyword: '' // 검색어
      },
      selectTab: {},
      tabIndex: 0,
    }
  },


  mounted () {
    this.id = this._uid
    this.selectTab = {[this.id]: '사업장(직접수행)'} //useTypes

    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.showPopup = false
        next(false); return
      }
      next(true)
    })
    this.$once('hook:destroyed', () => {
      backButtonRouteGuard()
    })
  },

  async created () {
    this.showPopup = this.value
    this.oldSelectFieldId = this.selectId
    await this.loadFieldList()
  },

  methods: {
    getFormattedDate(dateStr) {
      const dateMoment = moment(dateStr);
      if(dateMoment.isValid()) {
        return dateMoment.format('YYYY-MM-DD');
      } else {
        return '';
      }
    },
    async loadFieldList () {
      // popupSearchField를 여러개 사용할 경우, 중복호출이 발생하는 문제가 있어서, 열려있는 팝업에 대해서만 처리
      if (!this.showPopup) return
      // 데이터를 읽기 전 페이지 이동시 반복적으로 api를 호출하는 것을 막기위해 추가
      if (this.search.loading) return
      this.search.loading = true

      const page = this.page.current
      const perPage = this.page.perPage
      const keyword = this.search.keyword
      const projectId = this.projectId
      const type = this.selectTab[this.id]
      await this.$store.dispatch('project/LOAD_FIELD_LIST', {
        page,
        perPage,
        keyword,
        projectId,
        type
      })
      this.search.loading = false;
    },

    onClickTab (tabKey) {
      this.selectTab = {[this.id]: tabKey}

      this.page.current = 1
      this.selectField = {}

      this.loadFieldList()
    },

    handleClickClose () {
      this.$emit('input', false)
      this.$emit('handleClickClose')
    },

    handleClickSearch () {
      this.loadFieldList()
    },

    handleChangePage () {
      this.loadFieldList()
    },

    handleItemClickDetail (data) {
      if (this.selectField === data) {
        this.selectField = {}
      } else {
        this.selectField = data
      }
    },

    handleClickSelect () {
      this.$emit('input', false)
      this.$emit('handleClickSelect', this.selectField)
    }
  }
}

</script>


<style>

#popupSearchCompany > .vs-popup {
  width: 860px !important;
}

#popupSearchCompany > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0;
  margin: 0;
}

#popupSearchCompany > .vs-popup > .vs-popup--content > .vs-row {
  padding: 24px;

}

</style>

<style scoped>

.table-layout {
  border: 1px solid #cdcdcd;
}

.table-layout .trow {
  border-bottom: 1px solid #cdcdcd;
}

.table-layout .tcol {
  border-right: 1px solid #cdcdcd;
}

.vs-con-table.stripe .tr-values.active {
  background: rgb(102, 112, 203) !important;
  color: #fff;
  font-width: bold;
}

th, td {
  text-align: center !important;
}
th .vs-table-text {
  justify-content: center;
}
.textCenter {
  text-align: center;
}
</style>

<style>
  .popupSearchField > .vs-popup {
    width:1200px !important;
    max-width:100% !important;
  }
</style>
